// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.O9vivwyDxMqo3q {
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: flex-start;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-075, 6px) var(--ds-space-150, 12px) var(--ds-space-075, 6px) var(--ds-space-100, 8px);
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: transparent;
  color: var(--accent-text, var(--ds-text-subtle, #44546f));
  text-decoration: none;
  -webkit-user-select: none;
  user-select: none;
}
.O9vivwyDxMqo3q:hover {
  background-color: var(--accent-background-hovered, var(--ds-background-neutral-hovered, #091e4224));
  color: var(--accent-text-bolder, var(--ds-text, #172b4d));
}
.O9vivwyDxMqo3q:active {
  background-color: var(--accent-background-pressed, var(--ds-background-neutral-pressed, #091e424f));
  color: var(--accent-text-bolder, var(--ds-text, #172b4d));
}
@media print {
  .O9vivwyDxMqo3q {
    display: none;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listAddCardButton": `O9vivwyDxMqo3q`
};
export default ___CSS_LOADER_EXPORT___;
